import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Flip } from 'gsap/Flip'

gsap.registerPlugin(ScrollTrigger)

export const services = () => {
  const el = document.querySelector('.services')
  
  if (!el) return
  
  const pin = document.querySelector('.services__pin')
  const center = document.querySelector('.services__center')
  const centerSvg = document.querySelector('.services__center-svg')

  document.fonts.ready.then(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: pin,
        pin: true,
        pinSpacing: true,
        start: 'center center',
        end: 'bottom center+=200px',
        endTrigger: el,
        scrub: 1,
        onEnter: () => {
          gsap.to(center, { duration: 0.35, scale: 1, ease: 'power2.inOut' })
        },
        onEnterBack: () => {
          gsap.to(center, { duration: 0.35, scale: 1, ease: 'power2.inOut' })
        },
        onLeave: () => {
          gsap.to(center, { duration: 0.35, scale: 0, ease: 'power2.inOut' })
        },
        onLeaveBack: () => {
          gsap.to(center, { duration: 0.35, scale: 0, ease: 'power2.inOut' })
        }
      }
    })
    timeline.to(centerSvg, {
      rotate: '360deg'
    })
  })
}

export default () => {}
